declare global {
  interface Window {
    dataLayer: any;
  }
}

export const dataLayerTracking = (obj: any) => {
  try {
    window &&
      window?.dataLayer?.push({
        LOB: "Momverse",
        page_url: window.location.href,
        page_title: document.title,
        ...obj,
      });
  } catch (err) {
    console.log("GTM ERROR: ", err);
  }
};
